//
// locale_en.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/en.json';
import localeData from "react-intl/locale-data/en.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_en.js